import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$1d53 from '/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as prismicRuntime$f47f from '/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/node_modules/@nuxt/image/dist/runtime/providers/prismic.js'
import * as ipxRuntime$7972 from '/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "prismic",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$1d53, defaults: {} },
  ['prismic']: { provider: prismicRuntime$f47f, defaults: {} },
  ['ipx']: { provider: ipxRuntime$7972, defaults: undefined }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
